import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/base-service/base-service.service';
import { ServicoPeriodico } from '../../agendamentos/interfaces/servico-periodico';
import { ClienteEquipamento } from '../interfaces/cliente-equipamento';

@Injectable({
  providedIn: 'root'
})
export class ClienteEquipamentosService extends BaseService<ClienteEquipamento> {

  constructor(protected http: HttpClient) {
    super(http, 'equipamentos-cliente');
  }

  getAllByCliente(clienteId: number, queryParams: {} | null = null) {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([chave, valor]: [string, string]) => {
        params = params.set(chave, valor);
      });
    }

    return this.http.get<ClienteEquipamento[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/cliente/${clienteId}`, { params: params });
  }

  getServicosPeriodicos(id: number, queryParams: {} | null = null) {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([chave, valor]: [string, string]) => {
        params = params.set(chave, valor);
      });
    }

    return this.http.get<ServicoPeriodico[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}/servicos-periodicos`, { params: params });
  }
}
